"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreContext = void 0;
var React = require("react");
/**
 * Wrap our store object in something that ensures subscribing is possible.
 *
 * @param store The Store to wrap
 */
var makeSubscribable = function (store) {
    if (store.subscribe) {
        return store;
    }
    var listeners = [];
    return {
        get: store.get,
        put: function (key, value) {
            store.put(key, value);
            listeners.forEach(function (listener) { return listener(); });
        },
        subscribe: function (callback) {
            listeners.push(callback);
            return function () {
                return listeners.splice(listeners.findIndex(function (l) { return l === callback; }), 1);
            };
        },
    };
};
exports.StoreContext = React.createContext({});
var StoreContextProvider = function (_a) {
    var storeProp = _a.store, children = _a.children;
    var store = React.useRef(makeSubscribable(storeProp)).current;
    return (React.createElement(exports.StoreContext.Provider, { value: { store: store } }, children));
};
exports.default = StoreContextProvider;
//# sourceMappingURL=StoreContext.js.map